/** @flow */

import type { State } from "@store/reducers";
import type { FocusListsType } from "@modules/reporting/reducer/focus-lists/types";
import type {
  ManagerReport,
  ReportCharts,
  ManagerReportViewState,
  ReportData,
  ReportState,
} from "@modules/reporting/reducer/focus-lists/manager/types";

export type ManagerFocusListsSelector = (state: State) => $PropertyType<FocusListsType, "manager">;
export type GetReportDetails = (state: State) => ManagerReport;
export type GetReportCharts = (state: State) => ReportCharts;

export const getManagerFocusLists = (state: State): $PropertyType<FocusListsType, "manager"> =>
  state.reporting.focusLists.manager;

export const getReport = (state: State): ReportState => getManagerFocusLists(state).report;

export const getReportData = (state: State): ReportData[] => getReport(state).reportData || [];

export const getCharts = (state: State): ReportCharts => getReport(state).charts;

export const getReportDetails = (state: State): ?ManagerReport => getReport(state).details;

export const isLoading = (state: State): boolean =>
  state.reporting.focusLists.manager.report.requestsInProgress > 0;

export const isReportGenerateInProgress = (state: State): boolean => {
  return state.reporting.focusLists.manager.report.reportGenerateInProgress > 0;
};

export const getViewState = (state: State): ManagerReportViewState =>
  state.reporting.focusLists.manager.report.viewState;
